import React, { useState } from 'react';
import {
  Modal, Form, Input, Select, message,
} from 'antd';
import axios from 'axios';
import getToken from '../../../../../logic/utils/getToken';

const NAME_REGEX = /^[a-zA-Z0-9_-]{1,64}$/;

function CreateConfigModal({ open, onClose, onCreated }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const format = Form.useWatch('format', form);
  const name = Form.useWatch('name', form);
  const preview = name && format && NAME_REGEX.test(name) ? `${name}.${format}` : '—';

  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch (e) { return; }
    setSubmitting(true);
    try {
      const token = getToken();
      const res = await axios.post('/api/configs', values, { headers: { token } });
      if (res.data.status === 'success') {
        message.success('Конфиг создан');
        form.resetFields();
        onCreated(res.data.data.filename);
      }
    } catch (e) {
      if (e.response && e.response.status === 409) {
        form.setFields([{ name: 'name', errors: ['Файл с таким именем уже существует'] }]);
      } else {
        const txt = (e.response && e.response.data && e.response.data.error
          && e.response.data.error.text && e.response.data.error.text.rus)
          || 'Ошибка создания';
        message.error(txt);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Добавить файл"
      open={open}
      onCancel={() => { form.resetFields(); onClose(); }}
      onOk={handleSubmit}
      okText="Добавить"
      cancelText="Отмена"
      confirmLoading={submitting}
      destroyOnClose
    >
      <Form form={form} layout="vertical" initialValues={{ format: 'json' }}>
        <Form.Item
          label="Имя"
          name="name"
          rules={[
            { required: true, message: 'Укажите имя' },
            { pattern: NAME_REGEX, message: 'Только латиница, цифры, _ и -, 1-64 символа' },
          ]}
          extra="Без расширения. Латиница, цифры, _ и -"
        >
          <Input placeholder="terminal-main" autoFocus />
        </Form.Item>
        <Form.Item label="Формат" name="format" rules={[{ required: true }]}>
          <Select
            options={[
              { value: 'json', label: 'JSON' },
              { value: 'xml', label: 'XML' },
              { value: 'yaml', label: 'YAML' },
            ]}
          />
        </Form.Item>
        <div style={{ marginTop: 8, color: '#666' }}>
          {'Имя файла: '}
          <strong>{preview}</strong>
        </div>
      </Form>
    </Modal>
  );
}

export default CreateConfigModal;
